export default "__VITE_ASSET__Bbisp2jj__"